import { ProductComparisonData, ProductModel, BaseFeature } from './types';

// ویژگی‌های پایه برای ساعت‌های کودکان
const kidWatchBaseFeatures: BaseFeature[] = [
    {
        feature: "درجه دقت حسگرهای سلامتی",
        description: "سطح دقت سنسورهای پایش سلامت برای اندازه‌گیری دقیق‌تر داده‌ها",
    },
    {
        feature: "GPS",
        description: "مکان‌یابی دقیق با استفاده از سیستم موقعیت‌یاب جهانی",
    },
    {
        feature: "گواهی ضد آب",
        description: "دارای استاندارد مقاومت در برابر نفوذ آب برای استفاده در شرایط مرطوب",
    },
    {
        feature: "ظرفیت باتری (mAh)",
        description: "ظرفیت باتری به میلی‌آمپر ساعت برای مدت زمان استفاده مداوم",
    },
    {
        feature: "حافظه",
        description: "حجم حافظه داخلی برای ذخیره‌سازی اطلاعات و داده‌ها",
    },
    {
        feature: "دیسک",
        description: "واحد ذخیره‌سازی قابل ارتقاء یا تعویض داخل دستگاه",
    },
    {
        feature: "اندازه نمایشگر",
        description: "قطر یا سطح نمایشگر برای مشاهده راحت‌تر اطلاعات",
    },
    {
        feature: "جنس نمایشگر",
        description: "نوع متریال به کار رفته در صفحه نمایش برای مقاومت و وضوح بهتر",
    },
    {
        feature: "دوربین",
        description: "مشخصات و رزولوشن دوربین برای ثبت تصاویر و تماس‌های ویدیویی",
    },
    {
        feature: "تعداد هسته‌های پردازنده",
        description: "شماره هسته‌های پردازشی برای عملکرد سریع‌تر و روان‌تر",
    },
    {
        feature: "ضربان قلب",
        description: "پایش لحظه‌ای میزان ضربان قلب و نمایش روند سلامت قلب",
    },
    {
        feature: "رنگ بندی",
        description: "انتخاب بین رنگ‌های مختلف بدنه برای سلیقه‌های گوناگون",
    },
];

// محصولات دسته ساعت کودک
const kidWatches: ProductModel[] = [
    {
        id: "kid-watch-1",
        title: "KidWatch 1",
        icon: "/media/watch3.webp",
        rotation:-10,
        colorClass: "from-green-200 to-green-300", // رنگ سبز برای دسته ساعت کودک
        category: "kidwatch",
        features: [
            { feature: "درجه دقت حسگرهای سلامتی", value: "No" },
            { feature: "GPS", value: true },
            { feature: "گواهی ضد آب", value: "IPX7" },
            { feature: "ظرفیت باتری (mAh)", value: "710 mAh" },
            { feature: "حافظه", value: "1 GB" },
            { feature: "دیسک", value: "8 GB" },
            { feature: "اندازه نمایشگر", value: "1.83 اینچ" },
            { feature: "جنس نمایشگر", value: "IPS" },
            { feature: "دوربین", value: "0.3 MP" },
            { feature: "تعداد هسته‌های پردازنده", value: "Dual Core" },
            { feature: "ضربان قلب", value: false },
            { feature: "رنگ‌بندی", value: "Black/Blue/Pink/Silver" },
        ],
    },
    {
        id: "kid-watch-2",
        title: "KidWatch 2",
        icon: "/media/products/watches/watch2.webp",
        colorClass: "from-green-200 to-green-300",
        category: "kidwatch",
        features: [
            { feature: "درجه دقت حسگرهای سلامتی", value: "Ordinary" },
            { feature: "GPS", value: true },
            { feature: "گواهی ضد آب", value: "IPX6" },
            { feature: "ظرفیت باتری (mAh)", value: "800 mAh" },
            { feature: "حافظه", value: "2 GB" },
            { feature: "دیسک", value: "16 GB" },
            { feature: "اندازه نمایشگر", value: "1.90 اینچ" },
            { feature: "جنس نمایشگر", value: "IPS" },
            { feature: "دوربین", value: "0.3 + 0.3 MP" },
            { feature: "تعداد هسته‌های پردازنده", value: "Quad Core" },
            { feature: "ضربان قلب", value: true },
            { feature: "رنگ‌بندی", value: "Black/Orange" },
        ],
    },
    {
        id: "kid-watch-3",
        title: "KidWatch 3",
        icon: "/media/watch1.webp",
        colorClass: "from-green-200 to-green-300",
        category: "kidwatch",
        features: [
            { feature: "درجه دقت حسگرهای سلامتی", value: "Ordinary" },
            { feature: "GPS", value: true },
            { feature: "گواهی ضد آب", value: "IP67" },
            { feature: "ظرفیت باتری (mAh)", value: "800 mAh" },
            { feature: "حافظه", value: "1 GB" },
            { feature: "دیسک", value: "8 GB" },
            { feature: "اندازه نمایشگر", value: "1.30 اینچ" },
            { feature: "جنس نمایشگر", value: "IPS" },
            { feature: "دوربین", value: "3 MP" },
            { feature: "تعداد هسته‌های پردازنده", value: "Dual Core" },
            { feature: "ضربان قلب", value: true },
            { feature: "رنگ‌بندی", value: "Black" },
        ],
    },
    {
        id: "kid-watch-4",
        title: "KidWatch 4",
        icon: "/media/watch2.webp",
        colorClass: "from-green-200 to-green-300",
        category: "kidwatch",
        features: [
            { feature: "درجه دقت حسگرهای سلامتی", value: "Ordinary" },
            { feature: "GPS", value: true },
            { feature: "گواهی ضد آب", value: "IP67" },
            { feature: "ظرفیت باتری (mAh)", value: "730 mAh" },
            { feature: "حافظه", value: "1 GB" },
            { feature: "دیسک", value: "16 GB" },
            { feature: "اندازه نمایشگر", value: "2.02 اینچ" },
            { feature: "جنس نمایشگر", value: "TFT" },
            { feature: "دوربین", value: "3 MP rotating" },
            { feature: "تعداد هسته‌های پردازنده", value: "Quad Core" },
            { feature: "ضربان قلب", value: true },
            { feature: "رنگ‌بندی", value: "Orange" },
        ],
    },
    {
        id: "kid-watch-5",
        title: "KidWatch 5",
        icon: "/media/products/watches/watch4.webp",
        colorClass: "from-green-200 to-green-300",
        category: "kidwatch",
        features: [
            { feature: "درجه دقت حسگرهای سلامتی", value: "Ordinary" },
            { feature: "GPS", value: true },
            { feature: "گواهی ضد آب", value: "IP67" },
            { feature: "ظرفیت باتری (mAh)", value: "980 mAh" },
            { feature: "حافظه", value: "1 GB" },
            { feature: "دیسک", value: "16 GB" },
            { feature: "اندازه نمایشگر", value: "2.00 اینچ" },
            { feature: "جنس نمایشگر", value: "TFT" },
            { feature: "دوربین", value: "3 MP rotating" },
            { feature: "تعداد هسته‌های پردازنده", value: "Dual Core" },
            { feature: "ضربان قلب", value: true },
            { feature: "رنگ‌بندی", value: "Black/Silver" },
        ],
    },
];

// ترکیب همه محصولات (در اینجا فقط یک دسته داریم)
const allKidWatches = [...kidWatches];

// داده‌های نهایی برای ساعت‌های کودکان
export const kidWatchesData: ProductComparisonData = {
  baseFeatures: kidWatchBaseFeatures,
  categories: [
    { id: "all", label: "همه", products: allKidWatches },
    { id: "kidwatch", label: "ساعت کودک", products: kidWatches },
  ],
  allProducts: allKidWatches,
};